const Export = () => import(/* webpackChunkName: "export-group" */ '@/views/export/Export')

export default [
  {
    path: 'export',
    name: 'export',
    components: {
      studyContent: Export
    },
    meta: {
      title: '数据导出'
    }
  }
]
